package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.radar.options.RadarScaleOptions

@RadarDsl
class ScaleScope {
    var display: Boolean = true
    var min: Float? = null
    var max: Float? = null
    var suggestedMin: Float? = null
    var suggestedMax: Float? = null
    var beginAtZero: Boolean? = null
    var startAngle: Float? = null
    var chartBackgroundColor: ChartColor? = null

    private var angleLinesScope: AngleLineScope? = null
    private var pointLabelsScope: PointLabelScope? = null
    private var ticksScope: TickScope? = null
    private var gridScope: GridScope? = null

    fun angleLines(block: AngleLineScope.() -> Unit) {
        angleLinesScope = AngleLineScope().apply(block)
    }
    fun pointLabels(block: PointLabelScope.() -> Unit) {
        pointLabelsScope = PointLabelScope().apply(block)
    }
    fun ticks(block: TickScope.() -> Unit) {
        ticksScope = TickScope().apply(block)
    }
    fun grid(block: GridScope.() -> Unit) {
        gridScope = GridScope().apply(block)
    }

    internal fun build() = RadarScaleOptions(
        display = display,
        min = min,
        max = max,
        suggestedMin = suggestedMin,
        suggestedMax = suggestedMax,
        beginAtZero = beginAtZero,
        startAngle = startAngle,
        backgroundColor = chartBackgroundColor,
        angleLines = angleLinesScope?.build(),
        pointLabels = pointLabelsScope?.build(),
        ticks = ticksScope?.build(),
        grid = gridScope?.build(),
    )
}
